export enum PartValidationReason {
    IsNotValid = "IsNotValid",
    IsValid = "IsValid",
    IsCanceled = "IsCanceled",
    IsSuperseded = "IsSuperseded",
    IsMarkedDoNotSell = "IsMarkDoNotSell",
    IsChannelNotAuthorized = "IsChannelNotAuthorized",
    IsSoftFrozen = "IsSoftFrozen",
    IsHardFrozen = "IsHardFrozen",
    NoXrefMatches = "NoXrefMatches",
    OneXrefMatch = "OneXrefMatch",
    MultipleXrefMatches = "MultipleXrefMatches",
    IsMaoLimitExceeded = "IsMaoLimitExceeded",
    IsServicedAsComponents = "IsServicedAsComponents",
    IsMao = "IsMao",
    IsNprOnly = "IsNprOnly",
    ItemNotPriced = "ItemNotPriced",
    IsMaoNoPrice = "IsMaoNoPrice",
    IsMaoLimitExceededPriceNotCurrent = "IsMaoLimitExceededPriceNotCurrent",
    IsMaoLimitExceededNoStockQuantity = "IsMaoLimitExceededNoStockQuantity",
    CouldNotValidate = "CouldNotValidate",
    IsMaoLimitExceededPriceNotCurrentNoStockQuantity = "IsMaoLimitExceededPriceNotCurrentNoStockQuantity",
    IsProhibited = "IsProhibited",
    IncomingPartsNoStock = "IncomingPartsNoStock",
    IsDiscontinued = "IsDiscontinued",
    HasXrefNoPartRecord = "HaxXrefNoPartRecord",
    MaoSoftFrozen = "MaoSoftFrozen",
    MinimumQuantityNotMet = "MinimumQuantityNotMet"
}
